import BaseStore from './BaseStore'

export class PositionStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'positions'
  }
}

export default new PositionStore()


// WEBPACK FOOTER //
// ./src/stores/PositionStore.js